<template>
  <div class="page-maintenance-detail">
    <div
      class="container"
      :style="
        'padding-top:' +
        (from == 'tt-oil'
          ? '1.11rem'
          : active_menu_type == 1
          ? '2.56rem'
          : '2.22rem')
      "
    >
      <!-- 已选车型 -->
      <div
        class="car_model_full_info"
        :style="'top:' + (from == 'tt-oil' ? '0' : '1.06rem')"
      >
        <div class="header-box">
          <img
            class="vehicle-logo"
            :src="
              vehicle_info.brand_logo_url ||
              'https://oss-shell-elite-store.vchangxun.com/shop-wxapp/v3.2.0/default_car_logo.png'
            "
            alt=""
          />
          <div class="desc">
            {{ car_model_name_string }}
          </div>
        </div>
        <!-- <div
          class="car-config"
          v-if="active_menu_type == 1"
          @click="toMenuDetail"
        >
          <img src="@/assets/maintain/icon-car-black1.png" class="icon" />
          <span>车辆配置</span>
          <img
            src="@/assets/maintain/icon-yellow-arrow-right.png"
            class="icon1"
          />
        </div> -->
      </div>
      <banner></banner>
      <div class="content" v-if="valid_menus.length > 0">
        <!-- 左侧养护菜单tab -->
        <div
          class="content-left"
          :style="
            'top:' +
            (from == 'tt-oil'
              ? '1.11rem'
              : active_menu_type == 1
              ? '2.56rem'
              : '2.22rem')
          "
        >
          <div class="content-left-box">
            <div
              class="tab-box"
              v-for="(item, index) in valid_menus"
              :key="item.name"
            >
              <div
                @click="switchMenu(item, index)"
                :class="{
                  'tab-item': true,
                  active: active_menu_index == index,
                  'border-radius-next': active_menu_index == index - 1,
                  'border-radius-last': active_menu_index == index + 1,
                }"
              >
                <img
                  class="tab-icon"
                  :src="require(`@/assets/maintain/${item.icon}.png`)"
                  alt=""
                />
                <div class="tab-name">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div
              class="tab-item"
              :class="{
                'border-radius-next':
                  active_menu_index === valid_menus.length - 1,
              }"
            ></div>
          </div>
        </div>
        <!-- 右侧保养详情 -->
        <div class="content-right">
          <engine
            v-if="active_menu_type == 1"
            :query="dynamic_options"
            :vehicle_info="vehicle_info"
          ></engine>
          <machine-oil
            v-if="active_menu_type == 4"
            :query="dynamic_options"
            :brand_logo_url="brand_logo_url"
          ></machine-oil>
          <gearbox
            v-if="active_menu_type == 2"
            :query="dynamic_options"
            :brand_logo_url="brand_logo_url"
          ></gearbox>
          <tire
            v-if="active_menu_type == 3"
            :query="dynamic_options"
            :brand_logo_url="brand_logo_url"
          ></tire>
          <braking-system
            v-if="active_menu_type == 5"
            :query="dynamic_options"
            :brand_logo_url="brand_logo_url"
          ></braking-system>
          <coolant
            v-if="active_menu_type == 10"
            :query="dynamic_options"
            :fuel_type="vehicle_info.fuel_type"
          ></coolant>
        </div>
      </div>
      <div class="not-valid-menu" v-else>
        <img src="https://select-oil-oss.vchangyi.com/wxapp/no-menu-bg.png" />
        <div class="tip">暂无保养项目</div>
      </div>
    </div>
    <!-- 车型备注弹出层部分 -->
    <div class="popup-mask" v-show="showPopup"></div>
    <div :class="{ height0: !showPopup, 'popup-content': true }">
      <div class="content" v-show="showPopup">
        <div class="title">
          <span class="left">
            <span>{{ popupTitle }}</span>
          </span>
          <i
            class="close iconfont icon-guanbi font-10 color-grayC"
            @click.stop="cancelChoose"
          ></i>
        </div>
        <div class="sub-list">
          <div
            :class="{ subItem: true, multiple: item.multiple }"
            v-for="(item, index) in popupList"
            :key="index"
            @click="itemClickHandler(item)"
          >
            <span v-html="item.text"></span
            ><i class="iconfont icon-arrowR font-10 color-grayC" />
          </div>
        </div>
      </div>
    </div>
    <!-- 创建工单浮窗（从精养助手小程序 web-view 打开） -->
    <div v-if="from === 'curing-workbench-web-wx-app'" class="workorder-float">
      <img
        src="@/assets/maintenance/icon-workorder.png"
        alt="新建工单"
        @click="createWorkOrder"
      />
    </div>
    <!-- 操作指引弹窗 -->
    <div class="guide-mask" v-if="guide_show == '1'">
      <img
        class="guide-tips-img"
        src="@/assets/guide/guide-img4.png"
        alt="指引提示"
      />
      <div class="guide-exit" @click="exitGuide">
        <img
          class="icon-guide-exit"
          src="@/assets/guide/guide-exit.png"
          alt="退出指引"
        />
      </div>
    </div>

    <!-- 悬浮窗 -->
    <fab-button
      v-if="page_ready"
      :padding_bottom="from == 'curing-workbench-web-wx-app' ? 2.3 : 0"
    ></fab-button>
  </div>
</template>

<script>
import api from "@/apis/maintenance-api";
import Engine from "./components/Engine.vue";
import MachineOil from "./components/OilFilter.vue";
import Gearbox from "./components/Gearbox.vue";
import Tire from "./components/Tire.vue";
import BrakingSystem from "./components/BrakingSystem.vue";
import checkNotes from "../../mixins/check-notes";
import wx from "weixin-js-sdk";
import { default_menus } from "./constants/default-menus";
import FabButton from "@/components/FabButton.vue";
import Banner from "./components/Banner.vue";
import { setStatistics } from "@/utils/common";
import { wxShare } from "@/plugins/WxConfig.js";
import Coolant from "./components/Coolant.vue";
export default {
  name: "maintenance-detail",
  mixins: [checkNotes],
  components: {
    Engine,
    MachineOil,
    Gearbox,
    Tire,
    BrakingSystem,
    FabButton,
    Banner,
    Coolant,
  },
  data() {
    return {
      dynamic_options: {}, //切换tab时的动态参数，供组件使用，$route.query 为原始参数
      type: 0,
      dynamic_vehicle_ids: [], //可被修改的动态vehicle_ids,用于tab切换中的车型备注检查
      vehicle_info: {},
      car_model_name_string: "", //顶部展示的当前车型名称
      active_menu_index: 0, //表示激活的菜单索引,0表示第一项
      active_menu_type: 0, //表示激活的菜单type(唯一标识)，0表示未激活任何项
      valid_menus: [],
      brand_logo_url: "",
      args: {},
      vehicle_id: "", // 车型id
      from: "", // 来源
      guide_show: "2", // 是否开启操作指引 '1': 开启 '2': 关闭
      default_menus,
      page_ready: false,
    };
  },
  async mounted() {
    try {
      const { vehicle_id: id, vehicle_ids } = this.$route.query;
      this.from = window.sessionStorage.getItem("FROM");
      this.guide_show = window.sessionStorage.getItem("GUIDE_SHOW");
      this.dynamic_options = this.$route.query; //dynamic_options为传递给组件的参数，其中有vehicle_ids的数组和query_string形式
      this.vehicle_id = id || decodeURIComponent(vehicle_ids).split(",")[0];
      await this.fetchVehicleInfo(this.vehicle_id);
      await this.fetchValidMenus();
      this.updateValidMenus(); //更新展示可用菜单并激活当前对应菜单
      if (!window.localStorage.getItem("OILUSER")) {
        await setStatistics.apply(this, []);
      }
      this.page_ready = true;
      wxShare()
    } catch (error) {
      // 日志上报
      await api.setWebLogApi({
        error_message: `mounted: ${JSON.stringify(error)}`
      });
    }
  },
  methods: {
    /**
     * 通过vehicle_id获取车型详情
     */
    async fetchVehicleInfo(vehicle_id) {
      try {
        const res = await api.getVehicleDetailApi({
          vehicle_id,
        });
        if (res.code === 0) {
          const {
            brand_name,
            factory_name,
            model_alias,
            release_year,
            sales_name,
            displacement,
            model_name = "",
          } = res.data;
          this.vehicle_info = res.data;
          this.args = {
            brand_name,
            factory_name,
            model_alias,
            release_year,
            sales_name,
            displacement,
          };
          this.brand_logo_url = res.data.brand_logo_url;
          this.car_model_name_string = `${brand_name}-${factory_name}-${model_alias}-${release_year}-${sales_name}-${model_name}`;
        } else {
          await api.setWebLogApi({
            error_message: `获取车型详情失败: ${JSON.stringify(res)}`
          });
          this.$toast.show({
            showTime: 3,
            message: "获取车型详情失败",
            style: "error",
          });
        }
      } catch (error) {
        // 日志上报
        error && console.log("获取车型详情失败！");
        await api.setWebLogApi({
          error_message: `catch获取车型详情失败: ${JSON.stringify(error)}`
        });
      }
    },
    /**
     * 更新展示可用菜单并激活当前对应菜单
     */
    async updateValidMenus() {
      let temp_menu_type = null;
      let valid_menus = null;
      let temp_menu_index = null;

      try {
        // if (!sessionStorage.getItem("valid_menus")) {
        //   await this.fetchValidMenus();
        // }
        temp_menu_type = Number(this.$route.query.menu_type); //参数中的菜单type
        valid_menus = JSON.parse(sessionStorage.getItem("valid_menus")); //原始菜单数据
        temp_menu_index = valid_menus.findIndex(
          (i) => i.type == temp_menu_type
        );
        // 当前无开放菜单时，提示用户无保养项目
        if (this.$route.query.menu_type == 0 || valid_menus.length == 0) {
          this.$toast.show({
            showTime: 1.5,
            message: "暂无保养项目！",
            style: "error",
          });
        }
        //当前菜单在以开放菜单中不存在时，置为第一个开放的菜单并进行提示用户再次选择
        if (temp_menu_index == -1) {
          this.$toast.show({
            showTime: 1.5,
            message: "当前菜单已关闭！",
            style: "error",
          });
          this.active_menu_index_temp = temp_menu_index;
          this.active_menu_type_temp = valid_menus[0].type;
          this.switchMenu(valid_menus[0], temp_menu_index);
        } else {
          this.valid_menus = valid_menus;
          this.active_menu_index = temp_menu_index;
          this.active_menu_type = temp_menu_type;
        }
      } catch (error) {
        // 日志上传
        await api.setWebLogApi({
          error_message: `catch更新展示可用菜单并激活当前对应菜单: ${error}-->${temp_menu_type}-->${valid_menus}-->${temp_menu_index}`
        });
      }
      
    },
    /**
     * 获取开放菜单
     */
    async fetchValidMenus() {
      const res = await api.getValidMenusApi({
        scheme_id: this.$route.query.scheme_id || this.$route.query.id,
      });
      try {
        if (res.code === 0) {
          // console.log(res);
          console.log(res.data);
          const valid_menus_types = res.data //开放菜单type数组
            .filter((i) => i.is_show === 1)
            .map((i) => i.type);
          const temp_valid_menus = this.default_menus.filter((i) =>
            valid_menus_types.includes(i.type)
          ); //临时开放菜单项数组
          sessionStorage.setItem(
            "valid_menus",
            JSON.stringify(temp_valid_menus)
          );
        } else {
          await api.setWebLogApi({
            error_message: `获取开放菜单失败: ${JSON.stringify(res)}`
          });
          this.$toast.show({
            showTime: 3,
            message: "获取开放菜单失败",
            style: "error",
          });
        }
      } catch (error) {
        // 日志上传
        error && console.log("获取开放菜单失败！");
        await api.setWebLogApi({
          error_message: `catch获取开放菜单失败1: ${JSON.stringify(error)}：${JSON.stringify(res.data)}`
        });
        await api.setWebLogApi({
          error_message: `catch获取开放菜单失败2: ${error}`
        });
      }
    },
    /**
     * 点击切换保养菜单
     */
    async switchMenu(item, index) {
      if (this.dynamic_options.menu_type == item.type) return;
      const { vehicle_id, vehicle_ids } = this.$route.query;
      if (
        this.$route.query.menu_type === "1" ||
        this.$route.query.menu_type === "5"
      ) {
        this.dynamic_vehicle_ids = [vehicle_id];
      } else {
        this.dynamic_vehicle_ids = decodeURIComponent(vehicle_ids).split(",");
      }
      this.dynamic_vehicle_ids_query = encodeURIComponent(
        this.dynamic_vehicle_ids.join(",")
      );
      this.note_ready = false;
      this.active_menu_index_temp = index;
      this.active_menu_type_temp = item.type;
      switch (item.type) {
        case 1:
          if (this.$route.query.menu_type === "1") {
            this.dynamic_options = this.$route.query;
            this.note_ready = true;
            this.setNoteReadyAndSwitchTab();
            return;
          }
          await this.checkEngineOil();
          break;
        case 2:
          await this.checkTransmissionOil();
          break;
        case 3:
          await this.checkTireCategory();
          break;
        case 4:
          await this.checkOilFilterCategory();
          break;
        case 5:
          this.toBrakingSystem();
          break;
        case 10:
          this.toCoolant();
          break;
        default:
          break;
      }
    },
    toBrakingSystem() {
      const query_object = {
        scheme_id: this.$route.query.scheme_id,
        menu_type: 5,
        vehicle_id: this.dynamic_vehicle_ids[0],
        internal_from: this.$route.query.internal_from,
      };
      this.dynamic_options = query_object;
      this.setNoteReadyAndSwitchTab();
    },
    toCoolant() {
      const query_object = {
        scheme_id: this.$route.query.scheme_id,
        menu_type: 10,
        vehicle_id: this.dynamic_vehicle_ids[0],
        internal_from: this.$route.query.internal_from,
      };
      this.dynamic_options = query_object;
      this.setNoteReadyAndSwitchTab();
    },
    /**
     * 备注已完成选择后，执行tab切换初始化组件展示
     */
    setNoteReadyAndSwitchTab() {
      console.log(this.active_menu_type_temp, this.active_menu_index_temp);
      this.note_ready = true;
      this.active_menu_type = this.active_menu_type_temp;
      this.active_menu_index = this.active_menu_index_temp;
      this.showPopup = false;
    },
    /**
     * 创建工单（从精养助手小程序 web-view 打开）
     */
    createWorkOrder() {
      const vehicle_id = this.vehicle_id;
      wx.miniProgram.postMessage({
        data: {
          hash_id: vehicle_id, // 车型 hash_id
          guide_show: this.guide_show,
        },
      });
      wx.miniProgram.navigateBack();
    },
    /**
     * 退出操作指引
     */
    exitGuide() {
      this.guide_show = "2";
      window.sessionStorage.setItem("GUIDE_SHOW", this.guide_show);
    },
    // 查看车型详情
    toMenuDetail() {
      this.$router.push({
        path: "/maintenance-config",
        query: { vehicle_id: this.vehicle_id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  // display: flex;
  // flex-direction: column;
  width: 100%;
  padding-top: 222/100rem;
  background-color: #fafafa;
  .car_model_full_info {
    position: fixed;
    top: 106/100rem;
    left: 0;
    z-index: 10;
    // min-height: 116/100rem;
    padding: 0 27/100rem;
    font-weight: 500;
    color: #666666;
    line-height: 40/100rem;
    font-size: 28/100rem;
    background-color: #fff;
    width: 100%;
  }
  .header-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 99/100rem;
    // background-color: #fff;
    // padding: 0 27/100rem;
    z-index: 10;
    .vehicle-logo {
      width: 48/100rem;
      height: 48/100rem;
      margin-right: 17/100rem;
    }
    .desc {
      font-size: 24/100rem;
      color: #666;
    }
  }
  .car-config {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: 500;
    font-size: 24/100rem;
    color: #fbc409;
    line-height: 34/100rem;
    text-decoration-line: underline;
    padding-bottom: 20/100rem;
    // padding-top: 16/100rem;
    .icon {
      width: 32/100rem;
      height: 32/100rem;
      margin-right: 10/100rem;
    }
    .icon1 {
      width: 24/100rem;
      height: 24/100rem;
      margin-left: 10/100rem;
      margin-right: 0/100rem;
    }
  }
  .content {
    display: flex;
    background-color: #f3f3f3;
    margin-top: 20/100rem;
    .content-left {
      display: flex;
      flex-direction: column;
      width: 137/100rem;
      height: 100%;
      background-color: #f3f3f3;
      position: sticky;
      top: 200/100rem;
      .content-left-box {
        background-color: #fafafa;
        .tab-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 137/100rem;
          font-size: 20/100rem;
          color: #7a7a7a;
          background-color: #f3f3f3;
          .tab-icon {
            width: 58/100rem;
            height: 58/100rem;
            flex-shrink: 0;
          }
        }
        .active {
          background-color: #fafafa;
          color: #404040;
        }
        .border-radius-last {
          border-bottom-right-radius: 30/100rem;
        }
        .border-radius-next {
          border-top-right-radius: 30/100rem;
        }
      }
    }
    .content-right {
      flex: 1;
      min-height: calc(~"100vh - 2.05rem");
      background-color: #fafafa;
      padding: 0 27/100rem 0 27/100rem;
      overflow-x: hidden;
    }
  }
  .not-valid-menu {
    width: 100vw;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 133/100rem;
      height: 133/100rem;
    }
    .tip {
      color: #666666;
      font-size: 24/100rem;
      margin-top: 34/100rem;
    }
  }
}
// 车型备注弹出层部分
.popup-mask {
  position: absolute;
  top: 0;
  height: 100%;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3;
}
.popup-content {
  width: 100%;
  height: 539/100rem;
  background-color: #fff;
  transition: 0.3s;
  position: fixed;
  left: 0;
  bottom: 0;
  font-size: 14px;
  z-index: 99;
  padding: 0 26/100rem;
  .content {
    overflow: auto;
    .title {
      line-height: 92/100rem;
      height: 92/100rem;
      color: #c6c6c6;
      border-bottom: 2/100rem #f6f6f6 solid;
      display: flex;
      justify-content: space-between;
      font-size: 24/100rem;
      .left {
        i {
          margin-right: 17/100rem;
        }
        span {
          i {
            margin: 0 6/100rem;
          }
        }
      }
    }
    .sub-list {
      overflow: auto;
      height: 448/100rem;
      .subItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 40/100rem;
        // padding: 20/100rem 0;
        font-size: 26/100rem;
        min-height: 87/100rem;
        color: #404040;
        border-bottom: 2px #f6f6f6 solid;
      }
      .multiple {
        padding: 20/100rem 0;
      }
    }
  }
}
.workorder-float {
  width: 150/100rem;
  height: 150/100rem;
  position: fixed;
  right: 2/100rem;
  bottom: 85/100rem;
  z-index: 111;
  img {
    width: 100%;
    height: 100%;
  }
}
.height0 {
  height: 0;
}

.guide-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
  .guide-tips-img {
    width: 456/100rem;
    height: 114/100rem;
    position: absolute;
    bottom: 82/100rem;
    left: 43/100rem;
  }
  .guide-exit {
    width: 145/100rem;
    height: 68/100rem;
    position: absolute;
    top: 166/100rem;
    right: 19/100rem;
    z-index: 110;
    .icon-guide-exit {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
